import { useEffect, useState } from "react";

import SingleSelectDropdownFieldWithLabel from "../../../../../Common/Dropdowns/fixed-option-single-select-dropdown/SingleSelectDropdownWithLabel";
import { getValueByPath } from "../../../helper/functions";
import { useStaticData } from "../../../hooks/useStaticData";

export default function SingleSelectDropdown({ field = {}, data = {}, customOnChange }) {
  const { fetchDataValue } = useStaticData(field);
  const { modelKey, label, name, needsInitialValueFetch, formatValue } = field;
  const value = modelKey ? getValueByPath(data, modelKey) : undefined;
  const [initValue, setInitValue] = useState(value);

  useEffect(() => {
    const syncInitialValue = async () => {
      let formattedResponse = value;
      const shouldFetchInitialValue =
        needsInitialValueFetch && typeof value === "object" && value !== null;

      if (shouldFetchInitialValue) {
        const fetchedResponse = await fetchDataValue(value, {search: value});
        if (Array.isArray(fetchedResponse)) {
          formattedResponse = fetchedResponse[0];
        }
      }

      if (typeof formatValue === "function") {
        formattedResponse = formatValue(formattedResponse);
      }

      setInitValue(formattedResponse);
    };

    syncInitialValue();
  }, [value, needsInitialValueFetch, formatValue]);

  return (
    <SingleSelectDropdownFieldWithLabel
      label={label}
      url={field.url}
      queryParams={field.queryParams}
      queryParamBuilder={field.setQueryParams}
      initialPosition="top"
      isURLBased={field.isURLBased}
      fieldName={name}
      fieldValue={initValue}
      options={field.options || []}
      customOnChange={(fieldName, newValue) => customOnChange(fieldName, newValue)}
      disableClearable={field.disableClearable}
      dataFormatter={field.dataFormatter}
    />
  );
}
